"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBoolString = exports.trimDown = exports.generateRandomString = exports.caseInsensitiveContains = exports.firstLetterUp = exports.trimIfString = exports.isNullOrUndefined = exports.listFromCommaStrings = exports.listFromNewLineStrings = exports.commaStringsFromList = exports.newLineStringsFromList = void 0;
var htmlUtils_1 = require("./htmlUtils");
var newLineStringsFromList = function (list) { return (list ? list.reduce(function (prev, curr) { return (prev ? "".concat(prev, "\r\n").concat(curr) : curr); }, '') : ''); };
exports.newLineStringsFromList = newLineStringsFromList;
var commaStringsFromList = function (list) { return (list ? list.reduce(function (prev, curr) { return (prev ? "".concat(prev, ", ").concat(curr) : curr); }, '') : ''); };
exports.commaStringsFromList = commaStringsFromList;
var listFromNewLineStrings = function (string) { return (string ? string.split(/[\r\n]+/).map(function (d) { return d.trim(); }) : []); };
exports.listFromNewLineStrings = listFromNewLineStrings;
var listFromCommaStrings = function (string, defaultValue) {
    if (defaultValue === void 0) { defaultValue = []; }
    return (string ? string.split(',').map(function (d) { return d.trim(); }) : defaultValue);
};
exports.listFromCommaStrings = listFromCommaStrings;
var isNullOrUndefined = function (string) { return !string || string === '' || string === 'null' || string === 'undefined'; };
exports.isNullOrUndefined = isNullOrUndefined;
var trimIfString = function (obj) {
    if (typeof obj === 'string' || obj instanceof String) {
        if ((0, htmlUtils_1.isEmptyHtml)(obj)) {
            return undefined;
        }
        return obj.trim();
    }
    return obj;
};
exports.trimIfString = trimIfString;
var firstLetterUp = function (string) { return (string ? string.charAt(0).toUpperCase() + string.slice(1) : null); };
exports.firstLetterUp = firstLetterUp;
var caseInsensitiveContains = function (inputString, searchString) { return inputString && inputString.toLowerCase().indexOf(searchString) > -1; };
exports.caseInsensitiveContains = caseInsensitiveContains;
var generateRandomString = function (length) {
    if (length === void 0) { length = 8; }
    return (+new Date() + Math.random().toString(36)).slice(-length);
};
exports.generateRandomString = generateRandomString;
var trimDown = function (str, maxLength) { return (str.length > maxLength ? "".concat(str.slice(0, maxLength), "...") : str); };
exports.trimDown = trimDown;
var parseBoolString = function (str) {
    if (!str)
        return false;
    if (str === true)
        return true;
    var lowerStr = str.toLowerCase();
    return lowerStr === 'true' || lowerStr === '1';
};
exports.parseBoolString = parseBoolString;
